<script lang="ts">
	import { Theme } from '$lib/components/theme/index'
	import { selectedTheme } from '$lib/components/theme/selectedTheme'
	import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
	import { EnumsV1Theme } from '@sdk/Api'
	import { media } from '@store/media'
	import { currentTheme } from '@store/theme'
	import { onDestroy } from 'svelte'

	const themeKey = 'theme'

	function saveTheme(theme: Theme) {
		localStorage.setItem(themeKey, theme)
	}

	function loadTheme(): Theme {
		switch (localStorage.getItem(themeKey)) {
			case Theme.light:
				return Theme.light
			case Theme.dark:
				return Theme.dark
			case Theme.system:
				return Theme.system
			default:
				return null
		}
	}

	function onThemeChanged(theme: Theme) {
		saveTheme(theme)
		applySelectedTheme($media.dark)
	}

	function applySelectedTheme(preferDarkMode: string | boolean) {
		const theme = getSelectedTheme()

		if (theme === Theme.system) {
			if (preferDarkMode) {
				$currentTheme = Theme.dark
			} else {
				$currentTheme = Theme.light
			}
		} else {
			$currentTheme = theme
		}

		const isDark = $currentTheme === Theme.dark
		document.body.classList.toggle('dark', isDark)
	}

	function getSelectedTheme(): Theme {
		return $selectedTheme || getThemeFromTenantSettings()
	}

	function getThemeFromTenantSettings(): Theme {
		const theme = $tenantSettings.defaultTheme
		switch (theme) {
			case EnumsV1Theme.THEME_LIGHT:
				return Theme.light
			case EnumsV1Theme.THEME_DARK:
				return Theme.dark
			case EnumsV1Theme.THEME_SYSTEM:
				return Theme.system
			default:
				throw new Error(`Unknown theme: ${theme}`)
		}
	}

	onDestroy(() => {
		document.body.classList.remove('dark')
	})

	$selectedTheme = loadTheme()

	$effect(() => {
		applySelectedTheme($media.dark)
	})
	$effect(() => {
		if ($selectedTheme) {
			onThemeChanged($selectedTheme)
		}
	})
</script>
